import React, { useEffect, useState } from "react";
import { downloadSizes } from "../constant";
import MessageSvg from "../SVG/MessageSvg"; // Ensure this path is correct
import CleanBG from "../SVG/CleanBG";
import SoldOutsvg from "../SVG/SoldOutsvg";

function ASizeModal({
  show,
  handleClose,
  title,
  isChecked,
  titleColor,
  titleFontSize,
  pdfProductDetails,
  regularPrice,
  starColor,
  footer,
  showFooterInput,
  showTC,
  useUploadedBackground,
  description,
  nameFontSize,
  processedImage,
  pdfPriceColor,
  titleFontFamily,
  customPrice,
  nameColor,
  pdfcustomPrice,
  pdfbackground,
  bannerType,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
    } else {
      setTimeout(() => setVisible(false), 300);
    }
  }, [show]);

  if (!visible) return null;

  const styles = downloadSizes[bannerType] || {};
  const productDetailStyles = styles.productDetails || {};

  return (
    <div className={`modelContainer ${bannerType}`}>
      <div
        className={`modal-overlay ${show ? "show" : "hide"}`}
        onClick={handleClose}
      >
        <div
          className={`modal-content-live ${show ? "fade-in" : "fade-out"}`}
          onClick={(e) => e.stopPropagation()}
          style={{
            ...styles,
            display: "flex",
            flexDirection: "column",
            backgroundImage: `url(${
              useUploadedBackground && pdfbackground
                ? pdfbackground instanceof Blob
                  ? URL.createObjectURL(pdfbackground)
                  : pdfbackground
                : CleanBG
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div>
            <h1
              style={{
                color:titleColor,
                fontFamily: titleFontFamily,
                fontSize: titleFontSize,
              }}
              className="titlemodel"
            >
              {title}
            </h1>
          </div>
          <div
            className="product-details-container"
            style={productDetailStyles}
          >
            {pdfProductDetails?.map((product, index) => {
              const priceInDollars =
                (pdfcustomPrice || product.price) / 100;
              const formattedPrice = priceInDollars.toFixed(2);

              return (
                <div key={index}>
                  {product.name && (
                    <div
                      className="a4-nameTag-Modal"
                      style={{
                        fontSize: nameFontSize,
                        color:nameColor,
                        fontFamily: titleFontFamily,
                      }}
                    >
                      {product.name}
                    </div>
                  )}

                  {description && (
                    <div
                      className="a4-description"
                      style={{
                        fontFamily: titleFontFamily,
                      }}
                    >
                      {description}
                    </div>
                  )}

                  <div className="price-container">
                    <MessageSvg starColor={starColor} />
                    {(pdfcustomPrice || product.price) && (
                      <div
                        className="a44-priceTag-modal"
                        style={{
                          color: pdfPriceColor,
                          fontFamily: titleFontFamily,
                        }}
                      >
                        <p>Regular Price</p>
                        <div className="price-wrapper">
                          <div className="price-slash"></div>
                          <div className="RegularPrice-pdf">${regularPrice}</div>
                        </div>
                        <p>Only for Today</p>
                        <div className="Formated_Price_pdf">
                          {pdfcustomPrice
                            ? `$${pdfcustomPrice}`
                            : `$${formattedPrice}`}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          {isChecked && (
            <div className="sold-out-wrapper"
            style={{
              position: "absolute",
              top: "65%",
              left: "50%",
              height: 700,
              width: 700,
              transform: "translate(-50%, -50%)",
              zIndex: 10,
            }}>
              
              <SoldOutsvg />
            </div>
          )}

          {processedImage && (
            <div>
              <img
                src={processedImage}
                alt="Product"
                className="a4-transparent-image"
              />
            </div>
          )}

          <div
            className="footer-container"
            style={{
              fontFamily: titleFontFamily,
            }}
          >
            {(footer || showFooterInput) && (
              <div className="footer-stylemodel">{footer}</div>
            )}
            {showTC && <div className="T-and-C-landscape-modal">T & C</div>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ASizeModal;
